import { render } from "./CustomersPage.vue?vue&type=template&id=5b22ffa3"
import script from "./CustomersPage.vue?vue&type=script&lang=js"
export * from "./CustomersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__